export default function FormatMapSpecifics(mapConfig:any) {
	
	/*
		Colchester consultation maps
	*/
	if(mapConfig.id == 3593 || mapConfig.id == 3592) {
		mapConfig.quickResultLinkLabel = 'Comment on this site';
	}
	
	return mapConfig;
}